import axios from "axios";
import clientConfig from '../../env';
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { MdOutlineEditOff } from "react-icons/md";
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../../redux/user/user.actions';
import {formatPhoneNumber} from '../../utilities/utilities';

import { FaMale, FaFemale } from 'react-icons/fa'

function MyProfilePopup({ Data ,EditwindowVisible, sendDataToParent }) {

  const d = new Date(Data.birthday.split("-").reverse().join("-"));
  let dbmonth =  d.getMonth() >= 10 ? d.getMonth()+1 : `0${d.getMonth()+1}`;
  const [birthdate, setBirthdate] = useState(d.getDate());
  const [birthMonth, setBirthMonth] = useState(dbmonth);
  const [birthYear, setBirthYear] = useState(d.getFullYear());

  const initialState = {
    "firstName" : Data.firstName,
    "lastName" : Data.lastName,
    "email" : Data.email,
    "gender": Data.gender,
    "headline" : Data.headline,
    "location" : Data.location,
    "country": Data.country,
    "state": Data.state,
    "city": Data.city,
    "zip": Data.zip,
    "organization" : Data.organization,
    "organization_title" : Data.organization_title,
    "university" : Data.university,
    "university_degree" : Data.university_degree,
    "phone" : Data.phone,
    "interested_in" : Data.interested_in,
    "industry" : Data.industry,
    "classification" : Data.classification,
    "about": Data.about,
    "url": Data.url
  }

  const [
    { firstName, lastName, email, gender, headline, url, country, state, city, zip, organization, organization_title, university, university_degree, phone, interested_in, industry, classification, about },
    setState
  ] = useState(initialState);

  const [disabledSaveBtn, setDisabledSaveBtn] = useState(false);
  //const [errors, setErrors] = useState(null);

  const handleChange = e => {
    const { name, value } = e.target;
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  // const resetInputFields = () => {
  //   setState({ ...initialState });
  // };

  const handleSubmit = e => {
    e.preventDefault();
    setDisabledSaveBtn(true)
    const data = {
      "id": Data.userId,
      "email": email,
      "url": url,
      "firstName": firstName,
      "lastName": lastName,
      "description": about,
      "interested_in": interested_in,
      "industry": industry,
      "classification": classification,
      "gender": gender,
      "phone": phone,
      "birthday": `${birthYear}${birthMonth}${birthdate}`,
      "headline": headline,
      "country": country || "United States of America",
      "state": state,
      "city": city,
      "zip": zip,
      "organization": organization,
      "organization_title": organization_title,
      "university": university,
      "university_degree": university_degree,
    }

    const configheader = {
      "Content-Type": "application/json",
      "Authorization": `Barer ${Data.token}`
    }

    axios.post(`${clientConfig.siteUrl}wl/v1/user/${Data.userId}`, data, {
      headers: configheader
    }).then( response => {
      if(response.status === 200) {
        toast.success(response.data.message);
        sendDataToParent(!EditwindowVisible);
        // GetLatestUserData(Data.userId, { token: Data.token });
        getLatestData(Data.userId);
      }
      setDisabledSaveBtn(false);
    }).catch( error => {
      toast.error(error.response);
      setDisabledSaveBtn(false);
    });

  }
  const dispatch = useDispatch();
  const getLatestData = (id) => {
    axios.get(`${clientConfig.siteUrl}wl/v1/user/${id}`)
    .then( res => {
      let loginInfo = { token: Data.token }
      dispatch(setCurrentUser({ ...loginInfo, ...res.data}));
    }).catch( err => console.error(err));
  }

  return (
    <div className="my-profile-container">
      {/* Popup Container */}
      <div className="popup-backdrop"></div>
      <div className={`popup-container ${EditwindowVisible && "in"}`}>
        <div className="card">
          {false ? (
            <div>
              <p>Loading...</p>
            </div>
          ) : (
            <>
              <form onSubmit={handleSubmit}>
                <div className="card-header bg-transparent">
                  <button
                    type="button"
                    className="btn close-icon"
                    onClick={() => sendDataToParent(!EditwindowVisible)}
                  >
                    <IoMdClose />
                  </button>
                  <h2 className="h3">Edit</h2>
                  <p className="mb-0">Manage your Profile Content</p>
                </div>

                <div className="card-body">
                  <div className="form-row">
                    <div className="col-12 col-md-6 mb-3">
                      <InputField
                        label="First Name"
                        type="text"
                        value={firstName}
                        placeholder="Enter your Firstname"
                        name="firstName"
                        required={true}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <InputField
                        label="Last Name"
                        type="text"
                        value={lastName}
                        placeholder="Enter your Lastname"
                        name="lastName"
                        required={true}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </div>

                    {/* <div className="col-12 col-md-6 mb-3">
                    <InputField
                      label="Birth date"
                      type="date"
                      value={birthday && birthday.split("-").reverse().join("-")}
                      placeholder="Enter your Birthdate"
                      name="birthday"
                      required={true}
                      onChange={handleChange}
                    />

                  </div> */}

                    <div className="col-12 col-md-6 mb-3">
                      <label>
                        Email
                        <span className="ml-2 text-danger h5">
                          <MdOutlineEditOff size="14px" color="#3861b3" />
                        </span>
                      </label>
                      <p className="border py-2 px-3 m-0 rounded">
                        {email ? email : "example@mail.com"}
                      </p>
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <InputField
                        label="Phone/Mobile"
                        type="tel"
                        value={formatPhoneNumber(phone)}
                        placeholder="Enter your Mobile or Phone number"
                        name="phone"
                        required={true}
                        onChange={handleChange}
                        maxLength={10}
                      />
                    </div>

                    <div className="col-12 col-md-3 mb-3">
                      <InputField
                        label="City"
                        type="text"
                        value={city}
                        placeholder="Enter your City"
                        name="city"
                        required={true}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </div>

                    <div className="col-12 col-md-3 mb-3">
                      <InputField
                        label="State"
                        type="text"
                        value={state}
                        placeholder="Enter your State"
                        name="state"
                        required={true}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </div>

                    <div className="col-12 col-md-4 mb-3">
                      {/* <InputField
                    label="Country"
                    type="text"
                    value={country}
                    placeholder="Enter your Country name"
                    name="country"
                    required={true}
                    onChange={handleChange}
                  /> */}
                      <label>Country</label>
                      <select
                        className="form-control"
                        id="country"
                        name="country"
                        value={country}
                        required={true}
                        onChange={handleChange}
                      >
                        <option value="Afganistan">Afghanistan</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="American Samoa">American Samoa</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Anguilla">Anguilla</option>
                        <option value="Antigua & Barbuda">
                          Antigua & Barbuda
                        </option>
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Aruba">Aruba</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Belarus">Belarus</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bermuda">Bermuda</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bonaire">Bonaire</option>
                        <option value="Bosnia & Herzegovina">
                          Bosnia & Herzegovina
                        </option>
                        <option value="Botswana">Botswana</option>
                        <option value="Brazil">Brazil</option>
                        <option value="British Indian Ocean Ter">
                          British Indian Ocean Ter
                        </option>
                        <option value="Brunei">Brunei</option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Canary Islands">Canary Islands</option>
                        <option value="Cape Verde">Cape Verde</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                        <option value="Central African Republic">
                          Central African Republic
                        </option>
                        <option value="Chad">Chad</option>
                        <option value="Channel Islands">Channel Islands</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Christmas Island">
                          Christmas Island
                        </option>
                        <option value="Cocos Island">Cocos Island</option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo">Congo</option>
                        <option value="Cook Islands">Cook Islands</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Cote DIvoire">Cote DIvoire</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Curaco">Curacao</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czech Republic">Czech Republic</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Dominican Republic">
                          Dominican Republic
                        </option>
                        <option value="East Timor">East Timor</option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea">
                          Equatorial Guinea
                        </option>
                        <option value="Eritrea">Eritrea</option>
                        <option value="Estonia">Estonia</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Falkland Islands">
                          Falkland Islands
                        </option>
                        <option value="Faroe Islands">Faroe Islands</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="French Guiana">French Guiana</option>
                        <option value="French Polynesia">
                          French Polynesia
                        </option>
                        <option value="French Southern Ter">
                          French Southern Ter
                        </option>
                        <option value="Gabon">Gabon</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Gibraltar">Gibraltar</option>
                        <option value="Great Britain">Great Britain</option>
                        <option value="Greece">Greece</option>
                        <option value="Greenland">Greenland</option>
                        <option value="Grenada">Grenada</option>
                        <option value="Guadeloupe">Guadeloupe</option>
                        <option value="Guam">Guam</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Haiti">Haiti</option>
                        <option value="Hawaii">Hawaii</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="India">India</option>
                        <option value="Iran">Iran</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Isle of Man">Isle of Man</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Korea North">Korea North</option>
                        <option value="Korea Sout">Korea South</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Laos">Laos</option>
                        <option value="Latvia">Latvia</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libya">Libya</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lithuania">Lithuania</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Macau">Macau</option>
                        <option value="Macedonia">Macedonia</option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marshall Islands">
                          Marshall Islands
                        </option>
                        <option value="Martinique">Martinique</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mayotte">Mayotte</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Midway Islands">Midway Islands</option>
                        <option value="Moldova">Moldova</option>
                        <option value="Monaco">Monaco</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar">Myanmar</option>
                        <option value="Nambia">Nambia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherland Antilles">
                          Netherland Antilles
                        </option>
                        <option value="Netherlands">
                          Netherlands (Holland, Europe)
                        </option>
                        <option value="Nevis">Nevis</option>
                        <option value="New Caledonia">New Caledonia</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Niue">Niue</option>
                        <option value="Norfolk Island">Norfolk Island</option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Palau Island">Palau Island</option>
                        <option value="Palestine">Palestine</option>
                        <option value="Panama">Panama</option>
                        <option value="Papua New Guinea">
                          Papua New Guinea
                        </option>
                        <option value="Paraguay">Paraguay</option>
                        <option value="Peru">Peru</option>
                        <option value="Phillipines">Philippines</option>
                        <option value="Pitcairn Island">Pitcairn Island</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Republic of Montenegro">
                          Republic of Montenegro
                        </option>
                        <option value="Republic of Serbia">
                          Republic of Serbia
                        </option>
                        <option value="Reunion">Reunion</option>
                        <option value="Romania">Romania</option>
                        <option value="Russia">Russia</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="St Barthelemy">St Barthelemy</option>
                        <option value="St Eustatius">St Eustatius</option>
                        <option value="St Helena">St Helena</option>
                        <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                        <option value="St Lucia">St Lucia</option>
                        <option value="St Maarten">St Maarten</option>
                        <option value="St Pierre & Miquelon">
                          St Pierre & Miquelon
                        </option>
                        <option value="St Vincent & Grenadines">
                          St Vincent & Grenadines
                        </option>
                        <option value="Saipan">Saipan</option>
                        <option value="Samoa">Samoa</option>
                        <option value="Samoa American">Samoa American</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Sao Tome & Principe">
                          Sao Tome & Principe
                        </option>
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Africa">South Africa</option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Swaziland">Swaziland</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syria">Syria</option>
                        <option value="Tahiti">Tahiti</option>
                        <option value="Taiwan">Taiwan</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania">Tanzania</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Togo">Togo</option>
                        <option value="Tokelau">Tokelau</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad & Tobago">
                          Trinidad & Tobago
                        </option>
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Turks & Caicos Is">
                          Turks & Caicos Is
                        </option>
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Uganda">Uganda</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Erimates">
                          United Arab Emirates
                        </option>
                        <option value="United States of America">
                          United States of America
                        </option>
                        <option value="Uraguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Vatican City State">
                          Vatican City State
                        </option>
                        <option value="Venezuela">Venezuela</option>
                        <option value="Vietnam">Vietnam</option>
                        <option value="Virgin Islands (Brit)">
                          Virgin Islands (Brit)
                        </option>
                        <option value="Virgin Islands (USA)">
                          Virgin Islands (USA)
                        </option>
                        <option value="Wake Island">Wake Island</option>
                        <option value="Wallis & Futana Is">
                          Wallis & Futana Is
                        </option>
                        <option value="Yemen">Yemen</option>
                        <option value="Zaire">Zaire</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                      </select>
                    </div>

                    <div className="col-12 col-md-2 mb-3">
                      <InputField
                        label="Zip Code"
                        type="text"
                        value={zip}
                        placeholder="Zip Code"
                        name="zip"
                        required={true}
                        onChange={handleChange}
                        maxLength={6}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-0">
                      <div className="form-row">
                        <label className="col-12 text-left small-text">
                          Birthday{" "}
                          <span className="ml-2 text-danger h5">*</span>
                        </label>
                        <div className="form-group col col-md-4">
                          <select
                            name="month"
                            id="bmonth"
                            className="form-control"
                            onChange={(e) => setBirthMonth(e.target.value)}
                            value={birthMonth}
                            required={true}
                          >
                            <option value="">Select Month</option>
                            <SelectOption
                              rangeStart="1"
                              rangeEnd="12"
                              convertTo="month"
                            />
                          </select>
                        </div>

                        <div className="form-group col-3 col-md-4">
                          <select
                            name="day"
                            id="bday"
                            className="form-control"
                            onChange={(e) => setBirthdate(e.target.value)}
                            value={birthdate}
                            required={true}
                          >
                            <option value="">Select Day</option>
                            <SelectOption rangeStart="1" rangeEnd="31" />
                          </select>
                        </div>

                        <div className="form-group col col-md-4">
                          <select
                            name="year"
                            id="byear"
                            className="form-control"
                            onChange={(e) => setBirthYear(e.target.value)}
                            value={birthYear}
                            required={true}
                          >
                            <option value="">Select Year</option>
                            <SelectOption
                              rangeStart="1950"
                              rangeEnd={new Date().getFullYear()}
                              sorting="desc"
                            />
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <div className="form-row">
                        <label className="col-12 text-left">
                          Gender
                          <span className="ml-2 text-danger h5">*</span>
                        </label>
                        <div className="form-group mb-0 col-6">
                          <label
                            className="form-check-label btn btn-outline-secondary w-100 d-flex align-items-center justify-content-between"
                            htmlFor="radiomale"
                          >
                            <span>
                              <FaMale className="mr-1" />
                              Male
                            </span>
                            <input
                              type="radio"
                              name="gender"
                              id="radiomale"
                              value="Male"
                              onChange={handleChange}
                              checked={gender === "Male" ? true : false}
                            />
                          </label>
                        </div>

                        <div className="form-group mb-0 col-6">
                          <label
                            className="form-check-label btn btn-outline-secondary w-100 d-flex align-items-center justify-content-between"
                            htmlFor="radiofemale"
                          >
                            <span>
                              <FaFemale className="mr-1" />
                              Female
                            </span>
                            <input
                              type="radio"
                              name="gender"
                              id="radiofemale"
                              value="Female"
                              onChange={handleChange}
                              checked={gender === "Female" ? true : false}
                            />
                          </label>
                        </div>

                        {/* <div className="form-group mb-0 col-md-4">
                            <label className="form-check-label btn btn-outline-secondary w-100 d-flex align-items-center justify-content-between" htmlFor="radioother">
                                Other
                                <input type="radio" name="gender" id="radioother" value="Other" onChange={handleChange} checked={ gender === 'Other' ? true : false }/>
                            </label>
                        </div> */}
                      </div>
                    </div>

                    <div className="col-12 mb-3">
                      <InputField
                        label="Headline"
                        type="text"
                        value={headline}
                        placeholder="Enter your Headline"
                        name="headline"
                        required={true}
                        onChange={handleChange}
                        maxLength={160}
                      />
                    </div>

                    <div className="col-12">
                      <h5>Current Position</h5>
                      <div className="form-row">
                        <div className="col-12 col-md-6 mb-3">
                          <InputField
                            label="Title"
                            type="text"
                            value={organization_title}
                            placeholder="Enter Your Title/Role"
                            name="organization_title"
                            required={true}
                            onChange={handleChange}
                            maxLength={50}
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <InputField
                            label="Company"
                            type="text"
                            value={organization}
                            placeholder="Enter Company Name"
                            name="organization"
                            required={true}
                            onChange={handleChange}
                            maxLength={50}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <h5>Education</h5>
                      <div className="form-row">
                        <div className="col-12 col-md-6 mb-3">
                          {/* <InputField
                          label="Degree"
                          type="text"
                          value={university_degree}
                          placeholder="Enter Your Degree"
                          name="university_degree"
                          required={true}
                          onChange={handleChange}
                        /> */}

                          <SelectInput
                            label="Degree"
                            name="university_degree"
                            value={university_degree}
                            firstOption="Select your degree"
                            required={false}
                            onChange={handleChange}
                            options={[
                              "No formal education",
                              "High school GED",
                              "Vocational qualification",
                              "Some College",
                              "Associate degree",
                              "Bachelor's degree",
                              "Master's degree",
                              "Doctoral degree",
                            ]}
                          />
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                          <InputField
                            label="School"
                            type="text"
                            value={university}
                            placeholder="Enter School Name"
                            name="university"
                            required={true}
                            onChange={handleChange}
                            maxLength={50}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <SelectInput
                        label="Industry"
                        name="industry"
                        value={industry}
                        firstOption="Select Industry"
                        required={false}
                        onChange={handleChange}
                        options={industriesOptions}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <SelectInput
                        label="Interested In"
                        name="interested_in"
                        value={interested_in}
                        firstOption="Select Your Interest"
                        required={true}
                        onChange={handleChange}
                        options={["Mentoring", "Networking", "Business"]}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <SelectInput
                        label="Classification"
                        name="classification"
                        value={classification}
                        firstOption="Select Classification"
                        required={false}
                        onChange={handleChange}
                        options={["Student", "Professional", "Business Owner"]}
                      />
                    </div>

                    <div className="col-12 col-md-6 mb-3">
                      <InputField
                        label="Website Link (Optional)"
                        type="text"
                        value={url}
                        placeholder="Enter URL"
                        name="url"
                        required={false}
                        onChange={handleChange}
                        maxLength={200}
                      />
                    </div>

                    <div className="col-12 mb-3">
                      <label htmlFor="about">About</label>
                      <textarea
                        className="form-control"
                        name="about"
                        defaultValue={about}
                        onChange={handleChange}
                        placeholder="You can write about your years of experience, industry, or skills. People also talk about their achievements or previous job experiences."
                        rows="11"
                        spellCheck="false"
                        maxLength={1000}
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="card-footer bg-transparent text-muted text-right">
                  <button
                    type="submit"
                    className="btn btn-md btn-primary px-5 rounded-10"
                    disabled={disabledSaveBtn}
                  >
                    Save
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyProfilePopup;

export const InputField = ({
  label,
  type,
  placeholder,
  name,
  required,
  onChange,
  value,
  maxLength
}) => {
  return (
    <>
      <label htmlFor={name}>
        {label}
        {required && <span className="ml-2 text-danger h5">*</span>}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        name={name}
        className="form-control"
        onChange={onChange}
        required={required}
        value={value}
        maxLength={maxLength ? maxLength : ""}
      />
    </>
  );
};

const SelectOption = ({ rangeStart, rangeEnd, convertTo, sorting, ...otherProps }) => {
  let options = [];
  let months = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  for (let i = rangeStart; i <= rangeEnd; i++) {
    if (convertTo === 'month') {
      options.push(<option key={i} value={i < 10 ? `0${i}` : i}>{months[i - 1]}</option>);
    } else if (sorting === 'desc') {
      options.unshift(<option key={i} value={i}>{i}</option>);
    } else {
      options.push(<option key={i} value={i}>{i}</option>);
    }
  }
  return options;
};

export const SelectInput = ({
  label,
  name,
  firstOption,
  required,
  options,
  value,
  onChange
}) => {
  return (
    <>
      <label>{label}{required && <span className="ml-2 text-danger h5">*</span>}</label>
      <select name={name} value={value} required={required} onChange={onChange} className="form-control">
        <option value="">{firstOption}</option>
        { options?.length > 0 &&
          options.map( (item, index) => <option key={`${index}-${item}`} value={item}>{item}</option>)
        }
      </select>
    </>
  );
};

const industriesOptions = ["Accounting","Airlines/Aviation","Alternative Dispute Resolution","Alternative Medicine","Animation","Apparel & Fashion","Architecture & Planning","Arts and Crafts","Automotive","Aviation & Aerospace","Banking","Biotechnology","Broadcast Media","Building Materials","Business Supplies and Equipment","Capital Markets","Chemicals","Civic & Social Organization","Civil Engineering","Commercial Real Estate","Computer & Network Security","Computer Games","Computer Hardware","Computer Networking","Computer Software","Construction","Consumer Electronics","Consumer Goods","Consumer Services","Cosmetics","Dairy","Defense & Space","Design","Education Management","E-Learning","Electrical/Electronic Manufacturing","Entertainment","Environmental Services","Events Services","Executive Office","Facilities Services","Farming","Financial Services","Fine Art","Fishery","Food & Beverages","Food Production","Fund-Raising","Furniture","Gambling & Casinos","Glass, Ceramics & Concrete","Government Administration","Government Relations","Graphic Design","Health, Wellness and Fitness","Higher Education","Hospital & Health Care","Hospitality","Human Resources","Import and Export","Individual & Family Services","Industrial Automation","Information Services","Information Technology and Services","Insurance","International Affairs","International Trade and Development","Internet","Investment Banking","Investment Management","Judiciary","Law Enforcement","Law Practice","Legal Services","Legislative Office","Leisure, Travel & Tourism","Libraries","Logistics and Supply Chain","Luxury Goods & Jewelry","Machinery","Management Consulting","Maritime","Market Research","Marketing and Advertising","Mechanical or Industrial Engineering","Media Production","Medical Devices","Medical Practice","Mental Health Care","Military","Mining & Metals","Motion Pictures and Film","Museums and Institutions","Music","Nanotechnology","Newspapers","Non-Profit Organization Management","Oil & Energy","Online Media","Outsourcing/Offshoring","Package/Freight Delivery","Packaging and Containers","Paper & Forest Products","Performing Arts","Pharmaceuticals","Philanthropy","Photography","Plastics","Political Organization","Primary/Secondary Education","Printing","Professional Training & Coaching","Program Development","Public Policy","Public Relations and Communications","Public Safety","Publishing","Railroad Manufacture","Ranching","Real Estate","Recreational Facilities and Services","Religious Institutions","Renewables & Environment","Research","Restaurants","Retail","Security and Investigations","Semiconductors","Shipbuilding","Sporting Goods","Sports","Staffing and Recruiting","Supermarkets","Telecommunications","Textiles","Think Tanks","Tobacco","Translation and Localization","Transportation/Trucking/Railroad","Utilities","Venture Capital & Private Equity","Veterinary","Warehousing","Wholesale","Wine and Spirits","Wireless","Writing and Editing"]
